export interface ResponseBadgeActivityDetails {
    responseId: number;
    title: string;
    groupId: number;
    extraValue: string;
    deviceServiceAddress: string;
    canBadgeActivity: boolean;
    dll: string,
    dllDeviceType: string,
}

export interface ResponseBadgeActivityRequestParameters {
    responseId: number;
    searchTerm?: string;
    startDate?: Date;
    endDate?: Date;
    pageNumber?: number;
    recordCount?: number;
}

export enum BadgeActivityFilterOptions {
    PageNumber = "pagenumber",
    PageSize = "pagesize",
    SourceId = "sourceid",
    SearchTerm = "searchterm",
    StartDate = "startdate",
    EndDate = "enddate",
    File = "file",
    Type = "type",
}

export enum BadgeActivityRequestType {
    DeviceService = 1,
}

export enum BadgeActivityRenderType {
    Button = "Button",
    Table = "Table"
}

export interface BadgeActivityPaginatedRecord {
    id: string;
    dateTime: Date;
    messageType: string;
    messageText: string;
}

export interface BadgeActivityPaginatedResponse{
    pageCount: number;
    pageNumber: number;
    totalRecords: number;
    pageRecords: BadgeActivityPaginatedRecord[]
}

export interface BadgeActivityFilterParameters {
    searchTerm?: string;
    startDate?: string;
    endDate?: string;
    sourceId?: string;
}

export interface BadgeActivityPaginationParameters {
    requestType: number;
    pageNumber?: number;
    pageSize?: number;
    orderBy?: string;
    filter: BadgeActivityFilterParameters
}